import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class WebapiProvider extends HttpService {

    /**
     * Serviço de integração ao backend da api legada do hub
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('webapi', http, settingsService);
    }

}
